"use client";

import { getCurrentDate } from "@sa-nu/shared-utils/date";

import { STAY_TICKET_MASTER_CONFIG } from "../../../../../../../../constants";
import type { RoomTypeRoomDetailPayload } from "../../../../../../../_components/room-detail/room-detail-drawer-provider";
import { buildDirectConfirmUrl } from "../../../../../../../_components/room-type-reservation/_utils/build-direct-confirm-url";
import { buildLeadTimeUnavailablePeriods } from "../../../../../../../_components/room-type-reservation/_utils/unavailable-periods";
import { RoomTypeReservationCalendar } from "../../../../../../../_components/room-type-reservation/reserve/room-type-reservation-calendar";

// go/reserve/page.tsx の非会員 Stay 予約導線と同じ StayTicketTemplate.lookupKey。
// 拠点ページのプレビューでは provider (発行済み StayTicketUnit) が無いため、
// このテンプレートから辿った StayTicketMaster で日程・見積りを解決する。
const STAY_TICKET_MASTER_REFERENCE = { templateLookupKey: "stay-site-260709" };

const MAX_TICKETS_PER_UNIT = 4;

// このプレビュー導線は全 room type が同じ STAY_TICKET_MASTER_REFERENCE を使うため、
// STAY_TICKET_MASTER_CONFIG の対象判定は roomTypeId 単位ではなく base lookupKey の一致で行う。
const STAY_TICKET_MASTER_CONFIG_ENTRY = STAY_TICKET_MASTER_CONFIG.find(
  (config) =>
    config.base.stayTicketTemplateLookupKey ===
    STAY_TICKET_MASTER_REFERENCE.templateLookupKey,
);

// この導線は RoomTypeReserveContext を持たないため、mode を直接指定して呼び出す。
function SiteRoomTypeReserveInlineContent({
  roomTypeId,
  areaSlug,
  siteSlug,
}: {
  roomTypeId: string;
  areaSlug: string;
  siteSlug: string;
}) {
  return (
    <RoomTypeReservationCalendar
      mode="stayTicketMaster"
      roomTypeId={roomTypeId}
      stayTicketMasterReference={STAY_TICKET_MASTER_REFERENCE}
      evChargerAvailable={false}
      noCancelOptionConfig={
        STAY_TICKET_MASTER_CONFIG_ENTRY?.noCancelOption ?? null
      }
      // directConfirm 経由の /ticket-issue は選択日程分の StayTicket を実発行するため、
      // unit 1 枠に積める上限（MAX_TICKETS_PER_UNIT）を超える泊数を選ばせない。
      maxStayNights={MAX_TICKETS_PER_UNIT}
      unavailablePeriods={buildLeadTimeUnavailablePeriods(getCurrentDate())}
      onConfirm={(selection, { stayTicketTemplateLookupKey }) => {
        window.location.href = buildDirectConfirmUrl({
          // 1枚表示の base カードは lookupKey を渡さないため、base の lookupKey で補う。
          stayTicketTemplateLookupKey:
            stayTicketTemplateLookupKey ??
            STAY_TICKET_MASTER_REFERENCE.templateLookupKey,
          roomTypeId,
          selection,
          evChargerAvailable: false,
          returnTo: `/areas/${areaSlug}/sites/${siteSlug}`,
        });
      }}
    />
  );
}

/**
 * 拠点ページの非会員向けプレビュー経路で `useRoomDetailDrawer().open()` に渡す payload を組み立てる。
 */
export function buildRoomDetailPayloadForSiteReserve({
  roomTypeId,
  areaSlug,
  siteSlug,
}: {
  roomTypeId: string;
  areaSlug: string;
  siteSlug: string;
}): RoomTypeRoomDetailPayload {
  return {
    roomTypeId,
    reservation: {
      inlineContent: {
        render: () => (
          <SiteRoomTypeReserveInlineContent
            roomTypeId={roomTypeId}
            areaSlug={areaSlug}
            siteSlug={siteSlug}
          />
        ),
      },
    },
  };
}
